import IndexPage from '@dex/bubl-dash/src/lib/pages/IndexPage';
import PickupCategoryCreateEditForm from './Components/PickupCategoryCreateEditForm';
import PickupCategoryApi from './PickupCategoryApi';

export default function (app, settings) {

    app.addRoute({
        name: settings.key + "New",
        zone: settings.zone,
        path: settings.key + "/create",
        caps: settings.createCaps,
        component: IndexPage,
        componentProps: {
            header: {
                getTitle: () => "Add New",
                getButtons: settings.indexButtons,
                getTabs: settings.indexTabs,
                getTabCounts: settings.indexTabCounts,
            },
            create: {
                form: PickupCategoryCreateEditForm,
                getCreate: PickupCategoryApi.create,
                defaults: {},
                successMessage: "PickupCategory Saved",
                successRouteName: settings.key + "View",
                idKey: settings.idKey
            }
        },
    });

}